import { VoiceLanguage } from './util'
import { enConvertNumberToSpeechVoice, preloadEnVoice } from './en.js'
// 语音包列表
export const VoiceList = [
  {
    id: VoiceLanguage.English,
    text: 'English'
  }
]

function playVoice(url) {
  if (!url) return Promise.resolve()
  // 创建音频上下文和音频元素
  const audioElement = new Audio()
  audioElement.src = url
  audioElement.preload = 'metadata'
  audioElement.play()
  return new Promise(resolve => {
    audioElement.onended = () => {
      resolve()
    }
  })
}

async function playVoiceList(list) {
  if (!list || !list.length) return
  for (let url of list) {
    await playVoice(url)
  }
}

export function preloadVoice(language) {
  preloadEnVoice()
}

export function speechNumber(num) {
  if (!num) return Promise.resolve()
  num = Number(num)
  let voiceData = enConvertNumberToSpeechVoice(num)
  return playVoiceList(voiceData)
}
